/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The status of a {@link Revertible}.
 *
 * @public
 */
export var RevertibleStatus;
(function (RevertibleStatus) {
    /** The revertible can be reverted. */
    RevertibleStatus[RevertibleStatus["Valid"] = 0] = "Valid";
    /** The revertible has been disposed. Reverting it will have no effect. */
    RevertibleStatus[RevertibleStatus["Disposed"] = 1] = "Disposed";
})(RevertibleStatus || (RevertibleStatus = {}));
//# sourceMappingURL=revertible.js.map